/// <reference types="@types/googlemaps" />

import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import {
  HTTPWrapperContext,
  RequestConfigImplementation,
  REQUEST_METHODS,
  XHR_STRATEGIES
} from '@ptl/xhr';
import { environment } from 'src/environments/environment';
import { PharmacyLookupAutoCompleteResponse, RawPharmacy } from '../configs/interfaces/pharmacy-lookup/response/response.interface';

interface PharmacyCache {
  [id: string]: RawPharmacy;
}

@Injectable({
  providedIn: 'root'
})
export class PharmacyInformationService {
  constructor(
    private httpClient: HTTPWrapperContext
  ) { }

  pharmacyCache: PharmacyCache = {};

  byPharmacyNameAutoComplete(
    searchString: string,
    radius: number,
    zipCode: string
  ): Promise<PharmacyLookupAutoCompleteResponse> {
    let urlString = `${environment.infrastructure.connecture.lookupUrlPath}/Pharmacies/Search?` +
     `zip=${zipCode}` +
     `&radius=${radius}` +
     `&pharmacyName=${searchString}`

    const requestConfigImplementation = new RequestConfigImplementation({
      method: REQUEST_METHODS.GET,
      url: urlString,
      headers: new HttpHeaders({
        ddToken: window.btoa(environment.initData.brand.ddToken),
        ClientID: 'Highmark'
      })
    });

    let strategy = environment.infrastructure.connecture.httpStrategy || XHR_STRATEGIES.AXWAY_PRE_PASS;
    this.httpClient.setStrategy(strategy);
    return this.httpClient.makeRequest(requestConfigImplementation);
  }

  getPharmacyById(pharmId: string): Promise<RawPharmacy> {
    // check the cache first
    if (this.pharmacyCache[pharmId]) {
      return Promise.resolve(this.pharmacyCache[pharmId]);
    }

    let urlString = `${environment.infrastructure.connecture.lookupUrlPath}/Pharmacies/${pharmId}/?PharmacyIdType=0`;

    const requestConfigImplementation = new RequestConfigImplementation({
      method: REQUEST_METHODS.GET,
      url: urlString,
      headers: new HttpHeaders({
        ddToken: window.btoa(environment.initData.brand.ddToken),
        ClientID: 'Highmark'
      })
    });

    let strategy = environment.infrastructure.connecture.httpStrategy || XHR_STRATEGIES.AXWAY_PRE_PASS;
    this.httpClient.setStrategy(strategy);

    // intercept the response to cache the data when switching tabs
    return new Promise((resolve) => {
      this.httpClient.makeRequest(requestConfigImplementation).then((rawPharmacy:RawPharmacy) => {
        this.pharmacyCache[rawPharmacy.PharmacyID] = rawPharmacy;
        resolve(rawPharmacy);
      });
    });
  }
}
